import React, { useEffect, useMemo, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Button,
    CardActions,
    CardContent,
    Divider,
    Grid,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Skeleton,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import { gridSpacing } from 'store/constant';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import ApiLink from 'API';
import axios from 'axios';
import { useNavigate } from 'react-router';
import crown from '../../assets/crown.png';
import NumberFormat from 'react-number-format';
import ArticleIcon from '@mui/icons-material/Article';
import { exportToCSV } from 'ui-component/exportToCSV';
import moment from 'moment';
import SplitButton from 'ui-component/SplitButton';
const options = ['Preorder', 'Location'];
const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const TopPreorder = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [Data, setData] = useState({ preorderSale: [], locationSale: [] });
    const [SelectedIndex, setSelectedIndex] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);

    // Filter state
    const now = useMemo(() => new Date(), []);
    const [mode, setMode] = useState('month');             // 'month' | 'year'
    const [year, setYear] = useState(now.getFullYear());
    const [month, setMonth] = useState(now.getMonth() + 1);

    // Server param string
    const SelectMonthYear = useMemo(() => (
        mode === 'month' ? `${year}-${String(month).padStart(2, '0')}` : `${year}`
    ), [mode, year, month]);

    const yearOptions = useMemo(() => {
        const arr = [];
        const cur = now.getFullYear();
        for (let y = cur; y >= cur - 9; y--) arr.push(y);
        return arr;
    }, [now]);

    const filterLabel = mode === 'month' ? `${MONTH_NAMES[month - 1]} ${year}` : `Year ${year}`;

    const handleClose = () => { setAnchorEl(null); };
    const handleClick = (event) => { setAnchorEl(event.currentTarget); };
    useEffect(() => {
        let isMounted = true;
        const LoadData = async () => {
            try {
                if (SelectMonthYear !== undefined && SelectMonthYear !== null && SelectMonthYear !== '') {
                    setisLoading(true);
                    const response = await axios.get(ApiLink + '/api/requestproduct/preorder/rank/' + SelectMonthYear, {
                        withCredentials: true,
                        headers: { token: localStorage.getItem('token') }
                    });
                    if (isMounted) {
                        if (response.status === 200) {
                            if (response.data.data && response.data.data.length > 0) {
                                setData(response.data.data[0]);
                            } else {
                                setData({ preorderSale: [], locationSale: [] });
                            }
                            setisLoading(false);
                        } else if (response.status === 401) {
                            localStorage.clear();
                            navigate(0);
                        }
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setisLoading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                    console.log(error);
                }
            }
        };
        LoadData();
        return () => { isMounted = false; };
    }, [SelectMonthYear]);
    useEffect(() => {
        setAnchorEl(null);
    }, [SelectedIndex]);
    if (isLoading) {
        return (
            <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <CardContent sx={{ flex: 1 }}>
                    <Stack spacing={1.5}>
                        <Skeleton variant="text" width="40%" height={28} />
                        {[...Array(7)].map((_, i) => (
                            <Stack key={i} direction="row" spacing={2} alignItems="center">
                                <Skeleton variant="circular" width={32} height={32} />
                                <Stack sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="65%" />
                                </Stack>
                                <Skeleton variant="text" width={70} />
                            </Stack>
                        ))}
                    </Stack>
                </CardContent>
            </MainCard>
        );
    }

    return (
        <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <CardContent>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                <Grid container alignContent="center" justifyContent="space-between">
                                    <Grid item></Grid>
                                    <Grid
                                        container
                                        alignContent="center"
                                        justifyContent="space-between"
                                    // sx={{ display: 'flex', justifyContent: 'space-between' }}
                                    >
                                        <Grid item>
                                            <Stack direction="row-reverse">
                                                <MoreHorizOutlinedIcon
                                                    fontSize="small"
                                                    sx={{
                                                        color: theme.palette.primary[200],
                                                        cursor: 'pointer'
                                                    }}
                                                    aria-controls="menu-popular-card"
                                                    aria-haspopup="true"
                                                    onClick={handleClick}
                                                />
                                                <Menu
                                                    id="menu-popular-card"
                                                    anchorEl={anchorEl}
                                                    keepMounted
                                                    open={Boolean(anchorEl)}
                                                    onClose={handleClose}
                                                    variant="selectedMenu"
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    }}
                                                >
                                                    <Box sx={{ px: 2, py: 1, minWidth: 240 }}>
                                                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1, fontWeight: 700 }}>
                                                            FILTER
                                                        </Typography>
                                                        <Stack spacing={1}>
                                                            <TextField
                                                                select
                                                                size="small"
                                                                label="Period"
                                                                value={mode}
                                                                onChange={(e) => { setMode(e.target.value); handleClose(); }}
                                                                fullWidth
                                                            >
                                                                <MenuItem value="month">Month</MenuItem>
                                                                <MenuItem value="year">Year</MenuItem>
                                                            </TextField>
                                                            <Stack direction="row" spacing={1}>
                                                                <TextField
                                                                    select
                                                                    size="small"
                                                                    label="Year"
                                                                    value={year}
                                                                    onChange={(e) => { setYear(Number(e.target.value)); handleClose(); }}
                                                                    fullWidth
                                                                >
                                                                    {yearOptions.map((y) => (
                                                                        <MenuItem key={y} value={y}>{y}</MenuItem>
                                                                    ))}
                                                                </TextField>
                                                                {mode === 'month' && (
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        label="Month"
                                                                        value={month}
                                                                        onChange={(e) => { setMonth(Number(e.target.value)); handleClose(); }}
                                                                        fullWidth
                                                                    >
                                                                        {MONTH_NAMES.map((name, idx) => (
                                                                            <MenuItem key={idx + 1} value={idx + 1}>{name}</MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                    </Box>
                                                    <Divider sx={{ my: 0.5 }} />
                                                    <MenuItem
                                                        key={3}
                                                        onClick={async () => {
                                                            setAnchorEl(null);
                                                            const filename =
                                                                'TopSale-' +
                                                                options[SelectedIndex] +
                                                                '-Aone-' +
                                                                SelectMonthYear +
                                                                '-' +
                                                                moment(new Date()).format('YYYY-MM-DD-HH:mm:ss').toString();
                                                            const ExportData =
                                                                SelectedIndex === 0 ? Data?.preorderSale : Data?.locationSale;
                                                            const dataExcel = await Promise.all(
                                                                ExportData.map(async (item) => {
                                                                    return await {
                                                                        saleBy: item.saleBy,
                                                                        amout: item.amout
                                                                    };
                                                                })
                                                            );
                                                            exportToCSV(dataExcel, filename);
                                                        }}
                                                        id="excel"
                                                    >
                                                        <ListItemIcon>
                                                            <ArticleIcon fontSize="small" color="success" />
                                                        </ListItemIcon>
                                                        <ListItemText>Export Excel</ListItemText>
                                                    </MenuItem>
                                                </Menu>
                                                <Typography variant="h4">Sale Rank ({filterLabel})</Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid item>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <TextField
                                                    select
                                                    size="small"
                                                    label="Type"
                                                    value={SelectedIndex}
                                                    onChange={(e) => setSelectedIndex(Number(e.target.value))}
                                                    sx={{ minWidth: 130 }}
                                                >
                                                    {options.map((opt, idx) => (
                                                        <MenuItem key={opt} value={idx}>{opt}</MenuItem>
                                                    ))}
                                                </TextField>
                                                <img src={crown} alt="" />
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/* <Grid item xs={12} sx={{ pt: '16px !important' }}></Grid> */}
                            <Grid item xs={12}>
                                <PerfectScrollbar
                                    options={{ suppressScrollX: true }}
                                    style={{ height: '100%', maxHeight: 'calc(100vh - 380px)', minHeight: 320, overflowX: 'hidden' }}
                                >
                                    {Data[SelectedIndex === 0 ? 'preorderSale' : 'locationSale'].map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <Grid container direction="column" spacing={gridSpacing}>
                                                    {/* <Grid item></Grid> */}
                                                    <Grid item>
                                                        <Grid container alignItems="center" justifyContent="space-between">
                                                            <Grid item xs={2}>
                                                                <Avatar
                                                                    variant="rounded"
                                                                    sx={{
                                                                        width: 30,
                                                                        height: 30,
                                                                        borderRadius: '5px',
                                                                        // backgroundColor: theme.palette.success.light,
                                                                        // color: theme.palette.success.dark,
                                                                        ml: 2
                                                                    }}
                                                                >
                                                                    {index + 1}
                                                                </Avatar>
                                                            </Grid>

                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    color="inherit"
                                                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                                >
                                                                    {item.saleBy}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="h4"
                                                                    color="#f57224"
                                                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                                >
                                                                    <NumberFormat
                                                                        thousandsGroupStyle="thousand"
                                                                        value={item.amout}
                                                                        prefix="₭"
                                                                        decimalSeparator="."
                                                                        displayType="text"
                                                                        type="text"
                                                                        thousandSeparator={true}
                                                                        allowNegative={true}
                                                                    />
                                                                </Typography>
                                                                {/* <Typography variant="h3" color="inherit">
                                                                    {item.qty}
                                                                </Typography> */}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Grid item>
                                                        <Typography variant="subtitle2" sx={{ color: 'success.dark' }}>
                                                            {item.model}
                                                        </Typography>
                                                    </Grid> */}
                                                </Grid>
                                                <Divider sx={{ my: 1.5 }} />
                                            </div>
                                        );
                                    })}
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {/* <CardActions sx={{ p: 1.25, pt: 0, justifyContent: 'center' }}>
                        <Button size="small" disableElevation>
                            View All
                            <ChevronRightOutlinedIcon />
                        </Button>
                    </CardActions> */}
        </MainCard>
    );
};

export default TopPreorder;
